import React from "react";
import { Range } from 'rc-slider';
import "../../css/marketing-list/rc-slider.min.css";
import { Translate, withLocalize } from "react-localize-redux";
import { connect } from "formik";
import MarketingSection from '../marketingList/marketingSection';
import GreenSemaphore from "../../img/icons/GreenSemafor";
import YellowSemaphore from "../../img/icons/YellowSemafor";
import YellowSemaphoreReadonly from "../../img/icons/YellowSemaforReadonly";

import RedSemaphore from "../../img/icons/RedSemafor";
import BbCheckbox from '../styling/bbCheckbox';
import "./slider.scss";

const MARKS = {
    '0': "NA",
    '-1': "e",
    '-2': "d2",
    '-3': "d1",
    '-4': "c3",
    '-5': "c2",
    '-6': "c1",
    '-7': "b2",
    '-8': "b1",
    '-9': "a2",
    '-10': "a1"
}

const colors = ["#c32127", "#c32127", "#DA3925", "#f05123", "#F79215", "#fed206", "#CFCF21", "#a0cc3b", "#6AC36B", "#33ba9a", "#33ba9a"]

class SubjectRating extends React.Component {
    render() {
        return (
            <MarketingSection isOpen={this.props.open} name={this.props.translate(this.props.label)} >
                <div className="columns">
                    <div className="column bb-field">
                        <div style={{ textAlign: "center", marginBottom: ".5em", fontWeight: "bold" }}>Index Cribis</div>
                        <Range
                            className="subject-rating-range"
                            onChange={(values) => this.cribisIndexChange(values)}
                            marks={MARKS}
                            defaultValue={[-10, 0]}
                            value={[-this.props.formik.values.rating.cribisIndexMin, -this.props.formik.values.rating.cribisIndexMax]}
                            min={-10}
                            max={0}
                            allowCross={false}
                        />
                    </div>
                </div>

                <div className="columns" style={{ paddingTop: '1em' }}>
                    <div className="column">
                        <div className="bb-field">
                            <div style={{ paddingBottom: "0.5em" }}>
                                <label style={{ fontWeight: "bold" }}><Translate id="Report.Ratings.SemaphoreCribis" /></label>
                            </div>
                            {options.map((i, j) =>
                                <BbCheckbox key={`${j}-sem`} value={this.isChecked(this.props.formik.values.rating.semaphores, i.value)} onChange={e => this.onCheckboxChange(e, i.value, "semaphores")} children={i.label} id={`semaphores-${i.value}`} />)}
                        </div>
                    </div>
                    <div className="column">
                        <div className="bb-field">
                            <div style={{ paddingBottom: "0.5em" }}>
                                <label style={{ fontWeight: "bold" }}><Translate id="Report.Ratings.GroupSemaphoresCribis" /></label>
                            </div>
                            {options.map((i, j) =>
                                <BbCheckbox key={`${j}-group-sem`} value={this.isChecked(this.props.formik.values.rating.groupSemaphores, i.value)} onChange={e => this.onCheckboxChange(e, i.value, "groupSemaphores")} children={i.label} id={`groupSemaphores-${i.value}`} />)}
                        </div>
                    </div>
                </div>
            </MarketingSection>

        )
    }

    componentDidMount() {
        this.calculateGradient(this.props.formik.values.rating.cribisIndexMin, this.props.formik.values.rating.cribisIndexMax)
    }

    cribisIndexChange(values) {
        this.props.formik.setFieldValue('rating.cribisIndexMin', -values[0]);
        this.props.formik.setFieldValue('rating.cribisIndexMax', -values[1]);
        this.calculateGradient(-values[0], -values[1]);

    }

    calculateGradient(max, min) {
        const gray = "#dedede";
        if (min === -0) { min = 0; }
        let background = "";
        if (min === max) {
            background = gray
        }
        else {
            let gradientColors = [];
            for (let i = 10; i >= 0; i--) {
                if (i < min || i > max) {
                    gradientColors.push(gray)
                }
                else {
                    gradientColors.push(colors[i]);
                }
            }
            let tmpBackground = gradientColors.map((x, i, arr) => {
                if (x === gray && arr[i + 1] !== gray) {
                    return `${gray} ${i * 10 + 10}%`;
                }
                if (x !== gray && arr[i + 1] === gray) {
                    return `${x} ${i * 10}%, ${gray} ${i * 10}%`;
                }
                return `${x} ${i * 10}%`;

            });
            background = `linear-gradient(90deg, ${tmpBackground}`;
        }
        document.querySelector(".rc-slider-track-1").style.background = background;
    }

    isChecked(array, value) {
        var checked = array.find((element) => {
            return element === value;
        })
        return checked ? true : false;
    }

    onCheckboxChange(e, value, parameter) {
        let values;
        if (e) {
            values = this.props.formik.values.rating[parameter].concat(value)
        }
        else {
            values = this.props.formik.values.rating[parameter].filter(x => x !== value)
        }

        this.props.formik.setFieldValue(`rating.${parameter}`, values);
    }
}

const options = [
    { value: 1, label: <><GreenSemaphore style={{ width: "25px", height: "25px" }} /> &nbsp; <Translate id="Common.GreenSemaphore" /></> },
    { value: 2, label: <><YellowSemaphore style={{ width: "25px", height: "25px" }} /> &nbsp; <Translate id="Common.YellowSemaphore" /></> },
    { value: 3, label: <><RedSemaphore style={{ width: "25px", height: "25px" }} /> &nbsp; <Translate id="Common.RedSemaphore" /></> },
    { value: 4, label: <><YellowSemaphoreReadonly style={{ width: "25px", height: "25px" }} /> &nbsp; <Translate id="Common.GreySemaphore" /></> },
]

export default withLocalize(connect(SubjectRating));